import { render, staticRenderFns } from "./WorkFlow.vue?vue&type=template&id=186bf5d8&scoped=true"
import script from "./WorkFlow.vue?vue&type=script&lang=js"
export * from "./WorkFlow.vue?vue&type=script&lang=js"
import style0 from "./WorkFlow.vue?vue&type=style&index=0&id=186bf5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "186bf5d8",
  null
  
)

export default component.exports